import { render } from "./SectionReferenceWelcome.vue?vue&type=template&id=d5905312&scoped=true"
import script from "./SectionReferenceWelcome.vue?vue&type=script&lang=js"
export * from "./SectionReferenceWelcome.vue?vue&type=script&lang=js"

import "./SectionReferenceWelcome.vue?vue&type=style&index=0&id=d5905312&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5905312"]])

export default __exports__